import { Link } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";

export function SiteFooter() {
  const { lang } = useI18n();
  const isAr = lang === "ar";

  const product = [
    { to: "/" as const, label: isAr ? "كيف يعمل" : "How it works" },
    { to: "/browse" as const, label: isAr ? "تصفح" : "Browse" },
    { to: "/add-book" as const, label: isAr ? "أدرج كتابًا" : "List a book" },
    { to: "/faq" as const, label: isAr ? "الأسئلة الشائعة" : "FAQ" },
  ];
  const community = [
    { to: "/" as const, label: isAr ? "عن Book Swap" : "About" },
    { to: "/contact" as const, label: isAr ? "تواصل" : "Contact" },
  ];
  const legal = [
    { to: "/terms" as const, label: isAr ? "شروط الاستخدام" : "Terms of Use" },
    { to: "/privacy" as const, label: isAr ? "سياسة الخصوصية" : "Privacy Policy" },
  ];

  return (
    <footer className="border-t border-border bg-card/50 py-12">
      <div className="mx-auto grid max-w-6xl gap-8 px-4 sm:grid-cols-2 md:grid-cols-4">
        <div>
          <p className="font-serif text-lg font-bold text-primary">Book Swap</p>
          <p className="mt-2 text-sm text-muted-foreground">
            {isAr ? "تبادل الكتب مع جيرانك. مجاني، محلي، يحركه المجتمع." : "Exchange books with your neighbors. Free, local, community-powered."}
          </p>
        </div>
        <FooterCol title={isAr ? "المنتج" : "Product"} items={product} />
        <FooterCol title={isAr ? "المجتمع" : "Community"} items={community} />
        <FooterCol title={isAr ? "قانوني" : "Legal"} items={legal} />
      </div>
      <div className="mx-auto mt-10 max-w-6xl border-t border-border px-4 pt-6 text-center text-xs text-muted-foreground">
        © 2026 Book Swap. {isAr ? "مصمَّم للجيران." : "Built for neighbors."}
      </div>
    </footer>
  );
}

function FooterCol({ title, items }: { title: string; items: { to: any; label: string }[] }) {
  return (
    <div>
      <p className="text-sm font-semibold text-foreground">{title}</p>
      <ul className="mt-3 space-y-2">
        {items.map((it) => (
          <li key={it.label}>
            <Link to={it.to} className="text-sm text-muted-foreground hover:text-primary">{it.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
